// extracted by mini-css-extract-plugin
export default {"fileDropBox":"kxrmk","dragging":"TNky2","text":"hSh75","icon":"q7gyu hSh75","fileInput":"JLvWc","dirInput":"vs852"};